<template>
  <div class="admin-product-links">
    <div class="text-center mt-48">
      <div class="mb-16 width-400 m-auto text-left pl-8">
        <label class="label-required">{{ attributeName }}</label>
      </div>

      <div v-for="(item, i) in values" class="field mt-24">
        <div class="width-400 m-auto">
          <div class='user-single-tag-select product_select'>
            <multiselect
              v-model="values[i].product"
              :options="parsedProductOptions"
              :multiple="false"
              :searchable="true"
              :taggable="false"
              @input="onProductSelect($event, i)"
            />
            <input type="hidden" :name="`${fieldName}[${i}][product]`" :value="values[i].product">
          </div>
        </div>

        <div class="flex-row flex-justify-around mt-24">
          <div class="width-400">
            <div class="flex-row flex-justify-between pl-8 mb-8">
              <div class="flex-1">
                <label>Note (en)</label>
              </div>
              <span class="button btn-translate width-100 translate-to-ja">translate</span>
            </div>
            <input type="text" class="input translate-text width-300" v-model="values[i].note_en" />
          </div>

          <div class="width-400">
            <div class="flex-row flex-justify-between pl-8 mb-8">
              <div class="flex-1">
                <label>Note (ja)</label>
              </div>
              <span class="button btn-translate width-100 translate-to-en">translate</span>
            </div>
            <input type="text" class="input translate-text width-300" v-model="values[i].note_ja" />
          </div>
        </div>
      </div>

      <div class="width-100p m-auto text-right">
        <span class="button is-small" @click="addItem">Add</span>
      </div>
    </div>
    <input type="hidden" :value="inputtedValues" :name="fieldName" />
  </div>
</template>

<script>
import Multiselect from 'vue-multiselect'

export default {
  name: 'AdminProductLinks',

  components: {
    Multiselect
  },

  props: {
    attributeName: String,
    fieldName: String,
    valuesJson: String,
    productOptions: String,
  },

  data() {
    return {
      values: [{ 'product': '', 'note_en': '', 'note_ja': '' }],
      parsedProductOptions: []
    }
  },

  computed: {
    inputtedValues() {
      return JSON.stringify(this.values.filter(value => value.product))
    }
  },

  methods: {
    setupAllTranslateEvents() {
      const buttons = this.$el.querySelectorAll('.btn-translate');
      buttons.forEach(button => this.setupTranslateEvent(button));
    },

    setupTranslateEvent(button) {
      const newButton = button.cloneNode(true);
      button.parentNode.replaceChild(newButton, button);

      newButton.addEventListener('click', () => {
        const translateType = Array.from(newButton.classList).find(name => name.startsWith('translate-to'));
        const currentField = newButton.closest('.field');
        const index = Array.from(this.$el.querySelectorAll('.field')).indexOf(currentField);

        // 翻訳の方向を決定
        const isJaTranslation = translateType === 'translate-to-ja';

        // 現在のフィールド内での翻訳元と翻訳先を特定
        const currentNoteContainer = newButton.closest('.width-400');
        const originalInput = currentNoteContainer.querySelector('.translate-text');

        // 同じfield内の別の.width-400を見つける
        const noteContainers = currentField.querySelectorAll('.width-400');
        const targetContainer = Array.from(noteContainers).find(container => container !== currentNoteContainer);
        const targetInput = targetContainer.querySelector('.translate-text');

        const targetLang = isJaTranslation ? 'ja' : 'en';

        if (originalInput.value) {
          const axios = require('axios');
          axios.post('/admin/translate', { text: originalInput.value, lang: targetLang })
            .then(response => {
              const targetField = isJaTranslation ? 'note_ja' : 'note_en';
              this.$set(this.values[index], targetField, response.data.text);

              targetInput.value = response.data.text;
            })
            .catch(error => {
              console.log('ERROR: translation failed', error);
            });
        }
      });
    },

    addItem() {
      const lastIndex = this.values.length - 1;
      const lastValues = { ...this.values[lastIndex] };

      this.values.push({ 'product': '', 'note_en': '', 'note_ja': '' });

      this.$nextTick(() => {
        this.$set(this.values[lastIndex], 'note_en', lastValues.note_en);
        this.$set(this.values[lastIndex], 'note_ja', lastValues.note_ja);
        this.setupAllTranslateEvents();
      });
    },

    updateProduct(value, index) {
      this.$set(this.values[index], 'product', value);
    },

    onProductSelect(value, index) {
      this.$set(this.values[index], 'product', value);
    }
  },

  mounted() {
    try {
      const parsedValues = this.valuesJson ? JSON.parse(this.valuesJson) : [];
      this.parsedProductOptions = this.productOptions ? JSON.parse(this.productOptions) : [];

      if (parsedValues && parsedValues.length > 0) {
        parsedValues.forEach((value, index) => {
          if (index >= this.values.length) {
            this.values.push({ product: '', note_en: '', note_ja: '' });
          }
          this.$set(this.values, index, {
            product: value.product || '',
            note_en: value.note_en || '',
            note_ja: value.note_ja || ''
          });
        });
      }
    } catch (error) {
      console.error('Error in mounted:', error);
    }

    this.$nextTick(() => {
      this.setupAllTranslateEvents();
    });
  }
}
</script>
